import apiFetch from '../apiFetch'

export default function (token, campaignDetailsCountryId) {
  const queryParamsArray = [
    `campaignDetailsCountryId=${campaignDetailsCountryId}`
  ]
  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({ endPoint: `CampaignDetails/CampaignDetailsCountry${queryParams}`, method: 'DELETE', body: null, token: token })
}
